var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSuperAdmin || _vm.isAdmin)?_c('admin-dashboard'):_c('user-dashboard')}
var staticRenderFns = []

export { render, staticRenderFns }